import * as yup from 'yup';

export const validationResetPassword = yup.object().shape({
  cli_pass: yup.string().min(8, "Mínimo 8 caracteres").required("La contraseña es obligatoria"),
  cli_pass_confirm: yup.string()
    .oneOf([yup.ref('cli_pass'), null], 'Las contraseñas no coinciden')
    .required("Confirmar contraseña es obligatorio")
});
